let path = `${process.env.API_PATH}`

export const CredentialsApiList = [
    path +`/sso/getVerifyCode`,
    path + `/sso/login`,
    path + `/sso/getSMSCode`
    ,path + `/account/login`,
    path + `/account/getVerifyCode`
]
export const authorVendorApiList = [
    path + `/api/vendor/getReservationList`,
    path + `/api/vendor/startService`,
    path + `/api/vendor/reservation`,
    path + `/api/vendor/changeReservation`,
    path + `/api/vendor/verification`,
    path + `/api/vendor/getVerificationLink`,
    path + `/api/vendor/setVerificationLink`,
    path + `/api/vendor/getComment`,
    path + `/api/vendor/service`,
    path + `/api/vendor/exportReservation`,
    path + `/api/vendor/getEngineers`,
    path + `/api/vendor/findReservation`,
    path + `/api/vendor/addEngineer`,
    path + `/api/vendor/delEngineer`,
    path + `/api/vendor/getExportStatus`,
    path + `/api/vendor/closeReSetup`,
    path + `/api/vendor/getUploadQAFileURL`,
    path + `/api/vendor/changePassord`,
    path + `/api/vendor/checkQAFileStatus`,
    path + `/api/vendor/noCodeVerification`
]


// WEBPACK FOOTER //
// ./src/api/requestApi.js